export default __webpack_public_path__ + "static/media/darkblue_polygon.4758d16b.png";